module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAsCAYAAAB7aah+AAAACXBIWXMAAAsSAAALEgHS3X78AAAA5klEQVRYw+3YPQrCQBCG4VeJipXeIbew9AaCFp7An3K3sdBK0Mq0OYJN9Byewlo7O0GFtclCiEo2uFrN1wQWZh5mttpUjDH8IwGAVqoFxEAfqHnsfwcSYBKkBzEw/MEgNdvXQgOHoiVwfHMeAvOC2n6QXWFBFt9Mlge2wM3j6ur51dlMN1F08aVopdoWqvKnCCSQQAIJJJBAAgkkkEACffFYzmSilbp67N/8BK0ciq/AAegAjV+urreJoq7jA/sFepSoOaffU4mah4WSEkWJVmqdPqxds7d3NAYMbn9OQmDmOgmwA0ZPBKwno70VQigAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/icon-phone.png
// module id = vWvD
// module chunks = 1